export let loadingPlaceholder = "rPRrR";
export default {loadingPlaceholder};